import Loadable from '../../components/loadable';

const AllEventsReport = Loadable({
  loader: () => import('../../pages/reports/all_events_report/all_events_report'),
});

angular.module('gym').value('AllEventsReport', AllEventsReport);

const AllEventsReportFiltersModal = Loadable({
  loader: () => import('../../pages/reports/all_events_report/all_events_report_filters_modal'),
});

angular.module('gym').value('AllEventsReportFiltersModal', AllEventsReportFiltersModal);
